'use strict';exports.__esModule = true;
var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _reduxForm = require('redux-form');
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);

var _CompanyField = require('../CompanyContactUs/CompanyField/CompanyField');var _CompanyField2 = _interopRequireDefault(_CompanyField);

var _reduxFormValidators = require('../../../helpers/reduxFormValidators');
var _constants = require('../../../constants');
var _index = require('../../index');

var _ConsultationForm = require('./ConsultationForm.scss');var styles = _interopRequireWildcard(_ConsultationForm);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;} // Modules
// Components
// Helpers
// Styles
var ConsultationForm = function (_Component) {_inherits(ConsultationForm, _Component);function ConsultationForm() {var _temp, _this, _ret;_classCallCheck(this, ConsultationForm);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.




    handleSubmit = function (evt) {
      _this.props.handleSubmit(_this.props.onSubmit)(evt);
      return true;
    }, _this.

    fetchReCaptchaToken = function (evt) {
      _this.props.fetchReCaptchaToken(evt);
      _this.handleSubmit(evt);
    }, _temp), _possibleConstructorReturn(_this, _ret);}ConsultationForm.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {if (!this.props.formSubmitted && nextProps.formSubmitted) {this.props.reset();}};ConsultationForm.prototype.

  render = function render() {
    var translate = this.props.translate('companyPage', 'contactsForm');

    return (
      _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.formWrap, this.props.className) },
        _react2.default.createElement('div', { className: styles.title }, this.props.translate('companyPage', 'formTitle')),

        _react2.default.createElement('form', { noValidate: 'noValidate' },
          _react2.default.createElement(_reduxForm.Field, {
            field_id: this.props.field_id,
            name: 'name',
            component: _CompanyField2.default,
            type: 'text',
            placeholder: translate('name').toString() + '*',
            validate: [_reduxFormValidators.required],
            translateForError: this.props.translate('errorFieldMessages'),
            isRtl: this.props.isRtl }),


          _react2.default.createElement(_reduxForm.Field, {
            field_id: this.props.field_id,
            name: 'phone_number',
            component: _CompanyField2.default,
            type: 'text',
            normalize: function normalize(value) {return value.replace(/[\D]/g, '');},
            placeholder: translate('phone').toString() + '*',
            validate: [_reduxFormValidators.required, _reduxFormValidators.phoneNumber],
            translateForError: this.props.translate('errorFieldMessages'),
            isRtl: this.props.isRtl }),

          _react2.default.createElement(_index.GoogleReCaptcha, {
              locale: this.props.locale,
              fetchToken: this.fetchReCaptchaToken,
              doReset: this.props.formSubmitted,
              captchaIdentifier: this.props.captchaIdentifier },

            _react2.default.createElement('button', { className: styles.submit },
              this.props.translate('companyPage', 'sendRequest'),
              this.props.formSubmitting && _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' })))),



        !!this.props.formConsultationError &&
        _react2.default.createElement('p', { className: styles.message },
          translate('submit_fail_message'), ' ', _react2.default.createElement('a', { href: 'mailto:' + _constants.supportEmail }, _constants.supportEmail))));




  };return ConsultationForm;}(_react.Component);


ConsultationForm.propTypes = {
  field_id: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  formConsultationError: _propTypes2.default.object,
  translate: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  className: _propTypes2.default.string,
  sharingUrl: _propTypes2.default.string,
  isRtl: _propTypes2.default.bool,
  formSubmitted: _propTypes2.default.bool,
  formSubmitting: _propTypes2.default.bool,
  reset: _propTypes2.default.func,
  fetchReCaptchaToken: _propTypes2.default.func,
  captchaIdentifier: _propTypes2.default.string };exports.default =


(0, _reduxForm.reduxForm)({
  form: 'Consultation-Form' })(
ConsultationForm);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Company/ConsultationForm/ConsultationForm.js
// module id = 382
// module chunks = 0